export default __webpack_public_path__ + "static/media/modal-peace-sign.565e78e3.svg";